import { useEffect } from 'react';

import { isSSR } from '@jsmdg/yoshi';
import { cartCache } from '../helper/cartCache';

function isCartPage(): boolean {
    if (isSSR) {
        return false;
    }

    return window?.location?.href?.includes('/cart') ?? false;
}

function useClearCartCacheOnCartPage(): void {
    useEffect(() => {
        if (!isCartPage()) {
            return;
        }

        cartCache.clear();
    }, []);
}

export { useClearCartCacheOnCartPage };
